import * as React from "react";
import { SVGProps } from "react";
const SvgChevronBoldRight = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 32" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M11.97 28a1 1 0 0 1-.55-1.835c4.059-2.665 8.045-6.101 11.528-9.934a.36.36 0 0 0-.001-.462c-3.483-3.833-7.47-7.268-11.526-9.933a1 1 0 0 1 1.098-1.672c4.196 2.756 8.313 6.303 11.909 10.259a2.361 2.361 0 0 1 0 3.152c-3.594 3.956-7.712 7.504-11.91 10.26a.986.986 0 0 1-.431.159L11.97 28Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgChevronBoldRight;
